export default __webpack_public_path__ + "static/media/Panaah_HomeBG.7d9a1e75.jpg";